import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export interface PaginationRowProps {
  results: any[];
  totalCount: number;
  filter: any;
  onPageChanged(page: number): void;
  onUpdateLimit(limit: number): void;
}

export const PAGE_LIMIT_ITEMS = [12, 25, 50, 100];
export const DEFAULT_LIMIT = PAGE_LIMIT_ITEMS[2];

type UsePagination = {
    page: string|number;
    limit: number;
    offset: number;
    onUpdateLimit(val: number): void;
    onPageChanged(val: number): void;
    updateSearchParams(key: string, value: string|number, resetPage?: boolean): void
}

export const usePagination = (): UsePagination => {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") ?? 1;
    const limit = searchParams.get("limit") ?? DEFAULT_LIMIT;
    const offset = useMemo(() => Math.max((Number(page) - 1) * Number(limit), 0), [limit, page]);

    const updateSearchParams = (key: string, value: string | number, resetPage?: boolean) => {
        if (value) {
            searchParams.set(key, String(value));
        } else {
            searchParams.delete(key);
        }

        if (resetPage) {
            searchParams.set("page", "1");
        }

        setSearchParams(searchParams, {
            preventScrollReset: true,
        });
    };

    const onUpdateLimit = (value) => {
        updateSearchParams("limit", value, true);
    };

    const onPageChanged = (newPage) => {
        updateSearchParams("page", newPage);
    };

    return {
        page,
        limit: Number(limit),
        offset,
        onUpdateLimit,
        onPageChanged,
        updateSearchParams
    };
};
